import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { AppProvider } from './js/context'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
import './styles/_global.scss'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <AppProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppProvider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
